module.exports = __webpack_public_path__ + "static/img/life.77dc4208.png";